
import { Component, Vue } from 'vue-property-decorator'
import { getPurchaseOrderListApp, updateOrderStatus, OrderParamsDTO, OrderListDto, getOrderNodeList } from '@/api/order'
import { Getter } from 'vuex-class'
import OrderListItem from '@/views/orderManage/template/OrderListItem.vue'
import SalesOrder from '@/views/orderManage/SalesOrder/SalesOrder.vue'
import SalesOrderReturn from '@/views/orderManage/SalesOrder/SalesOrderReturn.vue'

Component.registerHooks(['beforeRouteEnter'])
@Component({
  name: 'SalesOrderList',
  components: {
    OrderListItem,
    SalesOrder,
    SalesOrderReturn
  }
})
export default class SalesOrderList extends Vue {
  @Getter companyId!: string

  // 查询参数
  params: OrderParamsDTO = {
    companyId: '',
    startTime: '',
    endTime: '',
    pageIndex: 1,
    pageSize: 10,
    orderType: '',
    payStatus: ''
  }
  orderList: OrderListDto[] = []
  orderToggle = '0' // 订货单0，退货单1
  authorityNode = -1

  created () {
    this.params.companyId = this.companyId
    if (this.$route.params.orderToggle && this.$route.params.orderToggle == '1') {
      this.changeOrderToggle('1')
    } else {
      this.changeOrderToggle('0')
    }
    // 订单查询权限
    this.$eventBus.$on('sendauthorityNode', (bool) => {
      this.authorityNode = bool
    })
  }

  /**
   * @description: 订货单退货单切换
   * @param {*}
   * @return {*}
   */
  changeOrderToggle (type: string) {
    if (this.orderToggle === type) return
    this.orderToggle = type
  }

  /**
   * 跳转搜索界面
   */
  toSearch () {
    // topType 1 销售单 2 采购单
    // pageType 1订货单 2退货单
    let topType = this.$route.path.includes('purchaseOrderList') ? '2' : '1'
    let pageType = this.orderToggle === '0' ? '1' : '2'
    if (topType === '1') {
      this.$router.push({
        path: '/searchOrder',
        query: {
          pageType,
          topType,
          authorityNode: `${this.authorityNode}`
        }
      })
    } else {
      this.$router.push({
        path: '/searchOrder',
        query: {
          pageType,
          topType,
        }
      })
    }
  }
}
